export default "__VITE_ASSET__fc484843__"